import { Injectable } from '@angular/core';
import { IntercomAppId } from '../../constants-types';
import { InitDataService } from '../../system-services';

type Intercom = {
    Intercom: (command: 'boot' | 'update' | 'showSpace', options?: any) => void;
};

type WindowWithIntercom = Window & Intercom;

@Injectable({
    providedIn: 'root'
})
export class SalesChatBotService {
    constructor(private readonly initData: InitDataService) {}

    // Updates URL of the current page in Intercom for targeting rules
    updatePageURL() {
        (window as unknown as WindowWithIntercom).Intercom('update', {});
    }

    // Opens intercom chat
    triggerChatBot(spaceName = 'home') {
        (window as unknown as WindowWithIntercom).Intercom(
            'showSpace',
            spaceName
        );
    }

    // Provide identity on initialize
    initialize() {
        (window as unknown as WindowWithIntercom).Intercom('boot', {
            app_id: IntercomAppId,
            user_id: this.initData.user.userGuid,
            name: `${this.initData.user.firstName} ${this.initData.user.lastName}`,
            email: this.initData.user.email,
            hide_default_launcher: false,
            alignment: 'left',
            horizontal_padding: 20,
            vertical_padding: 20
        });
    }
}
